<div class="model-selection-bar">
  <div class="loading-spinner" *ngIf="isLoading()">
    <fa-icon  [icon]="faSpinner" class="spinner-icon fa-spin-pulse"></fa-icon>
  </div>
  
  <div class="dropdowns-container" *ngIf="!isLoading()">
   <div class="filters-container">
       <div class="selection-block">
         <label>Select SAT:</label>
         <p-select 
           [options]="sats" 
           [(ngModel)]="selectedSAT" 
           (ngModelChange)="onFilterChange()" 
           optionLabel="name" 
           optionValue="id" 
           [disabled]="isDropdownDisabled()"
           placeholder="Select a SAT"
           [ngClass]="getDropdownClase()">
        </p-select>
       </div>
       <div class="selection-block">
         <label>Select Region:</label>
         <p-select 
           [options]="regions" 
           [(ngModel)]="selectedRegion" 
           (ngModelChange)="onFilterChange()" 
           optionLabel="name" 
           optionValue="id" 
           [disabled]="isDropdownDisabled()"
           placeholder="Select a Region"
           [ngClass]="getDropdownClase()">
        </p-select>
       </div>
       <div class="selection-block">
         <label>Select Commodity:</label>
         <p-select 
           [options]="commodities" 
           [(ngModel)]="selectedCommodity" 
           (ngModelChange)="onFilterChange()" 
           optionLabel="name" 
           optionValue="id" 
           [disabled]="isDropdownDisabled()"
           placeholder="Select a Commodity"
           [ngClass]="getDropdownClase()">
        </p-select>
       </div>
       <div class="separator"></div>
       <div class="selection-block">
        <label>Select Project:</label>
        <p-select 
          [options]="projects" 
          [(ngModel)]="selectedProject" 
          optionLabel="shortName" 
          optionValue="id" 
          placeholder="Select a Project"
          (onChange)="onProjectSelect($event)">
          </p-select>
      </div>
      
     </div>
  </div>
</div>
